<template>
  <div class="panel has-background-dark tile-border">
    <p class="panel-heading has-text-centered has-text-white custom-panel-heading">LATEST RELEASES</p>

    <DashboardProgressBar
      :is-loading="false"
      :initial-color="'#53B700'"
      :loading-color="'#53B700'" />

    <div class="content release-notes-content has-background-dark tile-border p-3">
      <div v-for="(release, index) in dashboardReleases"
        :key="index">
        <div class="is-size-7 is-italic has-text-grey">
          {{ $filters.formatDateLocale(release.date, $user.info.locale) }}
        </div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <div>
            <span class="has-text-weight-bold is-size-6 mr-2">{{ release.title }}</span>
            <span v-if="index === 0"
              class="tag is-success">New</span>
          </div>

          <div v-if="release.link">
            <a :href="release.link"
              target="_blank">
              <span class="has-text-success mr-1">
                <i class="mdi mdi-open-in-new mdi-14px" />
              </span>
              <span class="has-text-success is-size-6">View</span>
            </a>
          </div>
        </div>

        <ul class="pb-4 is-size-7">
          <li v-for="(note, noteIndex) in release.notes"
            :key="noteIndex"><span v-html="formatNote(note)" /></li>
        </ul>
      </div>

      <div class="has-text-centered">
        <a href="#"
          @click="displayAllReleases">
          <span class="has-text-success is-size-7 has-text-weight-bold is-underlined">View All</span>
        </a>
      </div>
    </div>

    <ReleaseNotesModal v-if="isReleaseModalActive"
      :active.sync="isReleaseModalActive"
      @close="closeModal">
      <p slot="text-title">Release Notes</p>
    </ReleaseNotesModal>
  </div>
</template>

<script>
import DashboardProgressBar from '@/views/dashboard/DashboardProgressBar.vue'
import Releases from '@/assets/json/release-notes.json'
import { ReleaseNotesModal } from '@/components/BulmaModal'

export default {
  name: 'DashboardReleaseNotes',
  components: {DashboardProgressBar, ReleaseNotesModal},

  data() {
    return {
      isReleaseModalActive: false
    }
  },

  computed: {
    dashboardReleases() {
      return Releases.slice(0, 5)
    }
  },

  methods: {
    closeModal() {
      this.isReleaseModalActive = false
    },
    displayAllReleases() {
      this.isReleaseModalActive = true
    },
    formatNote(note) {
      if (typeof(note) == 'string' && note.includes(':')) {
        const [key, value] = note.split(':')
        return `<b>${key}</b>: ${value}`
      }
      return note
    }
  }
}
</script>

<style scoped>
.tile-border {
  border-radius: 20px !important;
}
.custom-panel-heading {
  border-radius: 20px 20px 0 0 !important;
  background-color:#495057 !important; ;
}
.release-notes-content {
  height: 300px; /* same with dashboard-jobs-chart height*/
  overflow-y: scroll;
}
</style>